import {Injectable} from '@angular/core';
import {GlobalConstantsComponent} from '../../shared/global-constants/global-constants.component';
import {HttpClient} from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private apiUrl = GlobalConstantsComponent.apiURL;

  constructor(
    private http: HttpClient,
  ) { }

  getUserById(id) {
    return this.http.get(`${this.apiUrl}user/get/`+id) as any;
  }

  getAllUsers(page, perPage, search?) {
    if(search){
      return this.http.get(`${this.apiUrl}care/getAllUsers?perPage=`+ perPage + '&page=' + page + '&qs=' + search) as any;
    }
    return this.http.get(`${this.apiUrl}care/getAllUsers?perPage=`+ perPage + '&page=' + page) as any;
  }

  generateAdminPass(userId){
    return this.http.get(`${this.apiUrl}care/generateAdminPass/`+ userId) as any;
  }

  getUserReservationMail(userId){
    return this.http.get(`${this.apiUrl}care/getUserReservationMail/`+ userId) as any;
  }
  
}
